import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonComponentLegacy } from './button/button.component';
import { SpinnerComponentLegacy } from './spinner/spinner.component';
import { ThemeComponentLegacy } from './theme/theme.component';
import { InputComponentLegacy } from './input/input.component';
import { TopbarComponentLegacy } from './topbar/topbar.component';
import { ListComponentLegacy } from './list/list.component';
import { ModalComponentLegacy } from './modal/modal.component';
import { PanelComponentLegacy } from './panel/panel.component';
import { ParagraphComponentLegacy } from './typography/paragraph/paragraph.component';
import { CaptionComponentLegacy } from './typography/caption/caption.component';

import { AnchorComponentLegacy } from './anchor/anchor.component';
import { IconComponentLegacy } from './icon/icon.component';
import { PhoneFormComponentLegacy } from './input/phone-form/phone-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreatePasswordComponentLegacy } from './input/create-password/create-password.component';
import { CheckboxComponentLegacy } from './checkbox/checkbox.component';
import { RadioComponentLegacy } from './radio/radio.component';
import { ReactiveCheckboxComponentLegacy } from './checkbox/reactive-checkbox/reactive-checkbox.component';
import { ToastComponentLegacy } from './toast/toast.component';
import { BackComponentLegacy } from './back/back.component';
import { CellComponentLegacy } from './cell/cell.component';
import { MenuComponentLegacy } from './menu/menu.component';
import { TabsComponentLegacy } from './tabs/tabs.component';
import { RouterModule } from '@angular/router';
import { ActionArticleComponentLegacy } from './layout/templates/action-article/action-article.component';
import { PageComponentLegacy } from './layout/templates/page/page.component';
import { BillboardArticleComponentLegacy } from './layout/templates/billboard-article/billboard-article.component';
import { InputGroupComponentLegacy } from './input/input-group/input-group.component';
import { VideoComponentLegacy } from './video/video.component';
import { NgxMaskModule } from './utils/ngx-mask/ngx-mask.module';
import { IConfig } from './utils/ngx-mask/config';
import { TypographyComponentLegacy } from './typography/typography/typography.component';
import { ScrollIntoViewDirective } from './utils/scroll-into-view.directive';
import { TextColorDirective } from './utils/text-color.directive';
import { ToggleComponentLegacy } from './toggle/toggle.component';
import { ProgressBarComponentLegacy } from './progress-bar/progress-bar.component';

import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgStreamingModule } from '@videogular/ngx-videogular/streaming';
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { StepsComponentLegacy } from './steps/steps.component';
import { SafeStylePipe } from './utils/safe-style.pipe';
import {
  CardBannerComponentLegacy,
  CardBodyComponentLegacy,
  CardComponentLegacy,
  CardFooterComponentLegacy,
  CardHeaderComponentLegacy,
} from './card/card.component';
import { BlockComponentLegacy } from './block/block.component';

import { CurrencyInputComponentLegacy } from './input/currency-input/currency-input.component';
import { CurrencySelectComponentLegacy } from './input/currency-select/currency-select.component';
import { EmptyStateComponentLegacy } from './layout/templates/empty-state/empty-state.component';
import { CellListComponentLegacy } from './cell-list/cell-list.component';
import { AccordionComponentLegacy } from './accordion/accordion.component';
import { AccordionContentDirectiveLegacy, AccordionItemDirectiveLegacy } from './accordion/accordion-item/accordion-item.directive';
import { TogglePipe } from './accordion/toggle.pipe';
import { IconBoundsComponentLegacy } from './icon/icon-bounds/icon-bounds.component';
import { NavComponentLegacy } from './nav/nav.component';
import { AutocompleteComponentLegacy } from './autocomplete/autocomplete.component';
import { HighlightPipe } from './autocomplete/highlight.pipe';
import { TrackerComponentLegacy } from './tracker/tracker.component';
import { ActionCellComponentLegacy } from './cell/action-cell/action-cell.component';
import { AvatarComponentLegacy } from './avatar/avatar.component';
import { ReelsComponentLegacy } from './layout/templates/reels/reels.component';
import { CardLtComponentLegacy } from './card/card-lt/card-lt.component';
import { TxCellComponentLegacy } from './cell/tx-cell/tx-cell.component';
import { ListItemDetailsComponentLegacy } from './list/list-item-details/list-item-details.component';
import { HeaderComponentLegacy } from './header/header.component';
import { BuiRowComponentLegacy } from './grid/row/bui-row/bui-row.component';
import { BuiColumnComponentLegacy } from './grid/column/bui-column/bui-column.component';
import { BuiTileComponentLegacy, TileCardComponentLegacy, TileListItemComponentLegacy } from './containers/bui-tile/bui-tile.component';
import { ClickStyleDirective } from './utils/clickable.directive';
import { ActionCardComponentLegacy } from './action-card/action-card.component';
import { CopyCellComponentLegacy } from './copy-cell/copy-cell.component';
import { SectionCardComponentLegacy } from './section-card/section-card.component';
import { NewCurrencySelectComponentLegacy } from './currency-select/new-currency-select.component';

import { UiSwitchModule } from 'ngx-ui-switch';
import { NumbersOnlyDirective } from './utils/numbers-only.directive';
import { SurveySelectorComponentLegacy } from './survey-selector/survey-selector.component';
import { TextareaComponentLegacy } from './textarea/textarea.component';
import { TranslateModule } from '@ngx-translate/core';
import { PillComponentLegacy } from './pill/pill.component';
import { EnhancedClickDirective } from './directives/enhanced-click.directive';
import { LabelCellComponentLegacy } from './label-cell/label-cell.component';
import { ActionDetailsCardComponentLegacy } from './action-details-card/action-details-card.component';
import { HeaderLabelCellComponentLegacy } from './cell/header-label-cell/header-label-cell.component';
import { CreditHistoryLineChartComponentLegacy } from './highcharts/credit-history-line-chart/credit-history-line-chart.component';
import { ProminentCellComponentLegacy } from './cell/prominent-cell/prominent-cell.component';
import { LottieComponent } from 'ngx-lottie';
import { BrightsideCurrencyMaskDirective } from './utils/brightside-currency-mask.directive';

export type { BrightsideCurrencyMaskOptions } from './utils/brightside-currency-mask';
export { brightsideCurrencyMaskitoOptions, brightsideCurrencyNumberParams } from './utils/brightside-currency-mask';
export { BrightsideCurrencyMaskDirective } from './utils/brightside-currency-mask.directive';
export type InputMaskOptions = Partial<IConfig> | (() => Partial<IConfig>);
export const ngxMaskOptions: InputMaskOptions = {};

@NgModule({
  imports: [
    CommonModule,
    NgxMaskModule.forRoot(ngxMaskOptions),
    ReactiveFormsModule,
    RouterModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    VgStreamingModule,
    LoadingBarModule,
    FormsModule,
    UiSwitchModule,
    TranslateModule,
    LottieComponent,
    BrightsideCurrencyMaskDirective,
    CreditHistoryLineChartComponentLegacy,
  ],
  declarations: [
    ButtonComponentLegacy,
    CardComponentLegacy,
    CardHeaderComponentLegacy,
    CardBodyComponentLegacy,
    CardFooterComponentLegacy,
    CardBannerComponentLegacy,
    SpinnerComponentLegacy,
    ThemeComponentLegacy,
    InputComponentLegacy,
    TopbarComponentLegacy,
    ListComponentLegacy,
    ModalComponentLegacy,
    PanelComponentLegacy,
    ParagraphComponentLegacy,
    CaptionComponentLegacy,
    AnchorComponentLegacy,
    IconComponentLegacy,
    PhoneFormComponentLegacy,
    CreatePasswordComponentLegacy,
    CheckboxComponentLegacy,
    RadioComponentLegacy,
    ReactiveCheckboxComponentLegacy,
    ToastComponentLegacy,
    BackComponentLegacy,
    CellComponentLegacy,
    CellListComponentLegacy,
    MenuComponentLegacy,
    TabsComponentLegacy,
    ActionArticleComponentLegacy,
    PageComponentLegacy,
    BillboardArticleComponentLegacy,
    InputGroupComponentLegacy,
    TypographyComponentLegacy,
    ScrollIntoViewDirective,
    TextColorDirective,
    ToggleComponentLegacy,
    VideoComponentLegacy,
    StepsComponentLegacy,
    SafeStylePipe,
    BlockComponentLegacy,
    CurrencyInputComponentLegacy,
    CurrencySelectComponentLegacy,
    EmptyStateComponentLegacy,
    AccordionComponentLegacy,
    AccordionItemDirectiveLegacy,
    AccordionContentDirectiveLegacy,
    TogglePipe,
    IconBoundsComponentLegacy,
    ProgressBarComponentLegacy,
    NavComponentLegacy,
    AutocompleteComponentLegacy,
    HighlightPipe,
    TrackerComponentLegacy,
    ActionCellComponentLegacy,
    AvatarComponentLegacy,
    ReelsComponentLegacy,
    CardLtComponentLegacy,
    TxCellComponentLegacy,
    ListItemDetailsComponentLegacy,
    HeaderComponentLegacy,
    BuiRowComponentLegacy,
    BuiColumnComponentLegacy,
    BuiTileComponentLegacy,
    TileCardComponentLegacy,
    TileListItemComponentLegacy,
    ClickStyleDirective,
    ActionCardComponentLegacy,
    CopyCellComponentLegacy,
    SectionCardComponentLegacy,
    NewCurrencySelectComponentLegacy,
    NumbersOnlyDirective,
    SurveySelectorComponentLegacy,
    TextareaComponentLegacy,
    PillComponentLegacy,
    EnhancedClickDirective,
    LabelCellComponentLegacy,
    ActionDetailsCardComponentLegacy,
    HeaderLabelCellComponentLegacy,
    ProminentCellComponentLegacy,
  ],
  exports: [
    ButtonComponentLegacy,
    CardComponentLegacy,
    CardHeaderComponentLegacy,
    CardBodyComponentLegacy,
    CardFooterComponentLegacy,
    CardBannerComponentLegacy,
    SpinnerComponentLegacy,
    ThemeComponentLegacy,
    InputComponentLegacy,
    TopbarComponentLegacy,
    ListComponentLegacy,
    ModalComponentLegacy,
    PanelComponentLegacy,
    ParagraphComponentLegacy,
    CaptionComponentLegacy,
    AnchorComponentLegacy,
    IconComponentLegacy,
    PhoneFormComponentLegacy,
    CreatePasswordComponentLegacy,
    CheckboxComponentLegacy,
    RadioComponentLegacy,
    ReactiveCheckboxComponentLegacy,
    ToastComponentLegacy,
    BackComponentLegacy,
    CellComponentLegacy,
    CellListComponentLegacy,
    MenuComponentLegacy,
    TabsComponentLegacy,
    ActionArticleComponentLegacy,
    PageComponentLegacy,
    BillboardArticleComponentLegacy,
    InputGroupComponentLegacy,
    TypographyComponentLegacy,
    ScrollIntoViewDirective,
    TextColorDirective,
    ToggleComponentLegacy,
    VideoComponentLegacy,
    StepsComponentLegacy,
    SafeStylePipe,
    BlockComponentLegacy,
    CurrencyInputComponentLegacy,
    CurrencySelectComponentLegacy,
    EmptyStateComponentLegacy,
    AccordionComponentLegacy,
    AccordionItemDirectiveLegacy,
    AccordionContentDirectiveLegacy,
    IconBoundsComponentLegacy,
    ProgressBarComponentLegacy,
    NavComponentLegacy,
    AutocompleteComponentLegacy,
    HighlightPipe,
    TrackerComponentLegacy,
    ActionCellComponentLegacy,
    AvatarComponentLegacy,
    ReelsComponentLegacy,
    CardLtComponentLegacy,
    TxCellComponentLegacy,
    ListItemDetailsComponentLegacy,
    HeaderComponentLegacy,
    BuiRowComponentLegacy,
    BuiColumnComponentLegacy,
    BuiTileComponentLegacy,
    TileCardComponentLegacy,
    TileListItemComponentLegacy,
    ClickStyleDirective,
    ActionCardComponentLegacy,
    CopyCellComponentLegacy,
    SectionCardComponentLegacy,
    NewCurrencySelectComponentLegacy,
    SurveySelectorComponentLegacy,
    NumbersOnlyDirective,
    TextareaComponentLegacy,
    PillComponentLegacy,
    EnhancedClickDirective,
    LabelCellComponentLegacy,
    ActionDetailsCardComponentLegacy,
    HeaderLabelCellComponentLegacy,
    CreditHistoryLineChartComponentLegacy,
    ProminentCellComponentLegacy,
    BrightsideCurrencyMaskDirective,
  ],
  providers: [],
})
export class BrightsideUiModule {}
